import React from 'react'
import {Form} from 'react-bootstrap'
import Spinner from 'react-bootstrap/Spinner'
import {GroupDetailsContext} from '../../../../context/Modal/GroupDetails'
import {AuditDetailsContext} from '../../../../context/Modal/AuditDetails'
import {AuditPaneContext} from '../../../../context/AuditPane'
import {AuditModalApiContext} from '../../../../context/AuditModalApi'
import {AuditModalBarContext} from '../../../../context/AuditModalBar'
import CustomSelectField from '../CustomComponents/CustomSelectField'
import CustomSelectFilters from '../CustomComponents/CustomSelectFilters'
import CustomAutoUpdateField from '../CustomComponents/CustomAutoUpdateField'
import CustomMultiSelectField from '../CustomComponents/CustomMultiSelectField'
import {withTranslation} from 'react-i18next'

function GroupDetailsForm(props) {
  const {
    audit_entities_attributes,
    allow_auto_update_fields,
    allow_user_update_fields,
    allow_user_without_edit_permission,

    setGroupDetails,
    setAllowAutoUpdateField,
    setAllowUserUpdateField,
    setAllowUserWithoutEditPermission,
  } = React.useContext(GroupDetailsContext)
  const {status} = React.useContext(AuditDetailsContext)
  const {
    groups,
    entities,
    getAllEntities,
    getEntityFields,
    getEntityUserFields,
    getEntityAutoFields,
    resetFilterReloading,
  } = React.useContext(AuditModalApiContext)
  const modalBar = React.useContext(AuditModalBarContext)
  const paneState = React.useContext(AuditPaneContext)
  const disabled = status === 'incomplete' && paneState.modalType === 'edit' ? true : false

  const user_update_fields = entities.entities.entities_details
    ? entities.entities.entities_details[0].user_update_fields
    : []

  const auto_update_fields = entities.entities.entities_details
    ? entities.entities.entities_details[0].auto_update_fields
    : []

  const filters = entities.entities.entities_details
    ? entities.entities.entities_details[0].filters
    : []

  // const filters = jsonFilter

  const fields = entities.entities.entities_details
    ? entities.entities.entities_details[0].fields
    : []

  const entity_id = entities.entities.entities_details[0].id

  React.useEffect(() => {
    if (groups.groups.length === 0) {
      getAllEntities()
      if (paneState.modalType === 'edit' || paneState.modalType === 'duplicate') {
        resetFilterReloading()
      }
    } else {
      if (
        (fields.length === 0 || audit_entities_attributes[0].entity_id !== entity_id) &&
        (paneState.modalType === 'edit' || paneState.modalType === 'duplicate')
      ) {
        resetFilterReloading()
        getEntityFields(audit_entities_attributes[0].entity_id)
      }
      if (
        allow_auto_update_fields &&
        auto_update_fields.length === 0 &&
        (paneState.modalType === 'edit' || paneState.modalType === 'duplicate')
      ) {
        getEntityAutoFields(audit_entities_attributes[0].entity_id)
      }
      if (
        allow_user_update_fields &&
        user_update_fields.length === 0 &&
        (paneState.modalType === 'edit' || paneState.modalType === 'duplicate')
      ) {
        getEntityUserFields(audit_entities_attributes[0].entity_id)
      }
    }
    //eslint-disable-next-line
  }, [groups.groups.length])

  const handleGroupChange = (index, e) => {
    if (audit_entities_attributes[index].entity_id !== e.value) {
      let newArr = [...audit_entities_attributes]
      audit_entities_attributes[index]['entity_id'] = e.value
      audit_entities_attributes[index]['entity_name'] = e.label
      audit_entities_attributes[index].audit_entity_field_attributes = {
        field_id: '',
        field_name: '',
      }
      audit_entities_attributes[index].audit_entity_filters_attributes = []
      audit_entities_attributes[index].audit_entity_auto_update_fields_attributes = []
      audit_entities_attributes[index].audit_entity_user_fields_attributes = []
      if (fields.length === 0 || e.value !== entity_id) {
        getEntityFields(e.value)
      }
      resetFilterReloading()
      setGroupDetails(newArr)
      setAllowAutoUpdateField(false)
      setAllowUserUpdateField(false)
      modalBar.setEditWarning(true)
    }
  }

  const handleDisplayFieldChange = (index, e) => {
    let newArr = [...audit_entities_attributes]
    audit_entities_attributes[index].audit_entity_field_attributes = {
      field_id: e.value,
      field_name: e.label,
    }
    setGroupDetails(newArr)
  }

  const handleAllowUsersChange = (index, e) => {
    let newArr = [...audit_entities_attributes]
    let fieldArr = e.map(item => {
      if (item.value !== '') {
        return {
          field_id: item.value,
          field_name: item.label,
        }
      }
      return true
    })
    audit_entities_attributes[index].audit_entity_user_fields_attributes = fieldArr
    setGroupDetails(newArr)
  }

  const getGroupOptionItem = () => {
    let optionItems = []
    if (groups.groups.length > 0) {
      optionItems = groups.groups.map(item => {
        return {
          label: item.name,
          value: item.id,
        }
      })
    }
    return optionItems
  }

  const getUserUpdateOptionItem = b => {
    let optionItems = []
    if (user_update_fields.length > 0) {
      var a = user_update_fields
      var c = a.filter(function(objFromA) {
        return !b.find(function(objFromB) {
          return objFromA.field_id === objFromB.field_id
        })
      })
      optionItems = c.map(item => {
        return {
          label: item.field_name,
          value: item.field_id,
        }
      })
    }
    if (optionItems.length > 0) {
      optionItems.unshift({label: 'Select All', value: 'select_all'})
    }
    return optionItems
  }

  const getDisplayFieldOptionItem = () => {
    let optionItems = []
    if (fields.length > 0) {
      optionItems = fields.map(field => {
        return {
          label: field.field_name,
          value: field.field_id,
        }
      })
    }
    return optionItems
  }

  // const scrollToBottom = () => {
  //   setTimeout(() => {
  //     var group_details_element = document.getElementById('group_details_form')
  //     if (
  //       group_details_element !== null &&
  //       group_details_element.scrollHeight > group_details_element.clientHeight
  //     ) {
  //       group_details_element.scrollTo({
  //         top: group_details_element.scrollHeight - group_details_element.clientHeight,
  //         left: 0,
  //         behavior: 'smooth',
  //       })
  //     }
  //   }, 1200)
  // }

  const groupMultifields = auto_update_attributes => {
    let fields = []
    let exists = false
    auto_update_attributes.map(auto_attr => {
      if (
        auto_attr.field_type === 'MultipleListField' ||
        auto_attr.field_type === 'MultipleEntityListField'
      ) {
        fields = fields.map(field => {
          if (field.field_id === auto_attr.field_id) {
            exists = true
            if (field.selectedValues === undefined) {
              field.selectedValues = []
            }
            field.selectedValues.push({label: auto_attr.value_name, value: auto_attr.value_id})
          }
          return field
        })
        if (!exists) {
          if (auto_attr.value_id !== '' && auto_attr.value_id !== undefined) {
            auto_attr.selectedValues = []
            auto_attr.selectedValues.push({label: auto_attr.value_name, value: auto_attr.value_id})
          } else {
            auto_attr.selectedValues = []
          }
          var index = auto_update_fields
            .map(function(e) {
              return e.field_id
            })
            .indexOf(auto_attr.field_id)
          let temp_field_data = auto_update_fields[index]
          if (temp_field_data === undefined) {
            auto_attr.values = []
          } else {
            auto_attr.values = temp_field_data.values
          }
          fields.push(auto_attr)
        }
      } else {
        var index1 = auto_update_fields
          .map(function(e) {
            return e.field_id
          })
          .indexOf(auto_attr.field_id)
        let temp_field_data = auto_update_fields[index1]
        if (temp_field_data === undefined) {
          auto_attr.values = []
        } else {
          auto_attr.values = temp_field_data.values
        }
        fields.push(auto_attr)
      }
      return true
    })
    return fields.filter(val => val.field_name !== 'Select All')
  }

  const setDefaultField = (group, i) => {
    if (
      group.audit_entity_field_attributes.field_id === '' &&
      fields.length > 0 &&
      entities.entities.entities_details[0].id === audit_entities_attributes[0].entity_id
    ) {
      var index = fields
        .map(function(e) {
          return e.is_primary_default
        })
        .indexOf(true)
      index = index !== -1 ? index : 0
      handleDisplayFieldChange(i, {label: fields[index].field_name, value: fields[index].field_id})
    }
  }

  const handleClearAutoUpdateCheckbox = () => {
    if (auto_update_fields.length === 0) {
      getEntityAutoFields(audit_entities_attributes[0].entity_id)
    }
    let newArr = [...audit_entities_attributes]
    audit_entities_attributes[0].audit_entity_auto_update_fields_attributes = []
    setGroupDetails(newArr)
    setAllowAutoUpdateField(!allow_auto_update_fields)
  }
  const handleClearUserUpdateCheckbox = () => {
    if (user_update_fields.length === 0) {
      getEntityUserFields(audit_entities_attributes[0].entity_id)
    }
    let newArr = [...audit_entities_attributes]
    audit_entities_attributes[0].audit_entity_user_fields_attributes = []
    setGroupDetails(newArr)
    setAllowUserUpdateField(!allow_user_update_fields)
    setAllowUserWithoutEditPermission(false)
  }

  const {t} = props
  let groupError,
    fieldError,
    auto_update_attributesError,
    audit_fields_attributesError = null
  if (modalBar.errors.length > 0) {
    modalBar.errors.map(err => {
      switch (err.error_field) {
        case 'group':
          groupError = err
          break
        case 'field':
          fieldError = err
          break
        case 'auto_updates_attributes':
          auto_update_attributesError = err
          break
        case 'audit_fields_attributes':
          audit_fields_attributesError = err
          break
        default:
          break
      }
      return true
    })
  }
  return (
    <div>
      {/* <h6>Choose your group to perform an audit on.</h6>
      <small>You can have upto 3 groups</small> */}
      <form
        id="group_details_form"
        className={
          audit_entities_attributes.auditStatus === 'incomplete'
            ? 'audit-forms form-data not-allowed'
            : 'audit-forms form-data'
        }
      >
        <div className="row multiple-groups">
          {audit_entities_attributes.map((singleGroup, index) => {
            setDefaultField(singleGroup, index)
            return (
              <div className="col-12">
                <label
                  className={`display_field required width-100-persent ${groupError &&
                    'required-circle'}`}
                >
                  Group
                </label>
                {groups.isLoading || groups.groups.length === 0 ? (
                  <div className="loader-height-37">
                    <Spinner animation="border" role="status" />
                  </div>
                ) : (
                  <CustomSelectField
                    disabled={disabled}
                    id={singleGroup.entity_id}
                    name={singleGroup.entity_name}
                    placeholder="Select Group"
                    optionItems={getGroupOptionItem()}
                    handleChange={e => handleGroupChange(index, e)}
                  />
                )}
                {groupError && <div className="text-danger">{groupError.error_message}</div>}
                <label
                  className={`display_field required width-100-persent mt-15 ${fieldError &&
                    'required-circle'}`}
                >
                  Display Field
                </label>
                <br></br>
                {entities.isFieldLoading || groups.groups.length === 0 ? (
                  <div className="loader-height-37">
                    <Spinner animation="border" role="status" />
                  </div>
                ) : (
                  <CustomSelectField
                    disabled={!singleGroup.entity_id || disabled ? true : false}
                    id={singleGroup.audit_entity_field_attributes.field_id}
                    name={singleGroup.audit_entity_field_attributes.field_name}
                    placeholder="Select Display Field"
                    optionItems={getDisplayFieldOptionItem()}
                    handleChange={e => handleDisplayFieldChange(index, e)}
                  />
                )}
                {fieldError && <div className="text-danger">{fieldError.error_message}</div>}
                <div style={{width: 100}}>
                  <label style={{marginTop: 15}}>Filter</label>
                </div>
                <div
                  className={
                    !singleGroup.entity_id || disabled
                      ? 'styled_checkbox not-allowed'
                      : 'styled_checkbox'
                  }
                >
                  <CustomSelectFilters
                    index={index}
                    isFilterLoading={entities.isFilterLoading}
                    filters={filters}
                    values={singleGroup.audit_entity_filters_attributes}
                    entity_id={entity_id}
                  />
                </div>
                <small>Optional</small>
              </div>
            )
          })}
          {/* {audit_entities_attributes.audit_entities_attributes.length < 3 ? (
            <div className="col-4">
              <Button variant="outline-secondary" onClick={audit_entities_attributes.showColumn}>
                Add Group
              </Button>
            </div>
          ) : null} */}
        </div>
        <div className="row">
          <div className="col-12">
            <div className="allow_auto_update_field">
              <span className="label-color-size">
                Automatically Update Fields <br />
                <small>Automatically update select fields of scanned items.</small>
              </span>
              <Form.Check
                type="switch"
                id="custom-switch"
                label=""
                className="ap-toggle mr-5 mt--12"
                onChange={() => handleClearAutoUpdateCheckbox()}
                checked={allow_auto_update_fields}
                disabled={!audit_entities_attributes[0].entity_id || disabled ? true : false}
              />
            </div>
            <div
              className={disabled ? 'row border-bottom-line not-allowed' : 'row border-bottom-line'}
            >
              {allow_auto_update_fields && (
                <>
                  {audit_entities_attributes.map((singleGroup, index) => {
                    // console.log(singleGroup.audit_entity_auto_update_fields_attributes)
                    return (
                      <div className="col-12">
                        {entities.isAutoFieldLoading ? (
                          <div className="loader-height-44">
                            <Spinner animation="border" role="status" />
                          </div>
                        ) : (
                          <CustomAutoUpdateField
                            index={index}
                            fields={auto_update_fields}
                            values={groupMultifields(
                              singleGroup.audit_entity_auto_update_fields_attributes
                            )}
                            selectedValues={singleGroup.audit_entity_auto_update_fields_attributes}
                          />
                        )}
                        {auto_update_attributesError && (
                          <div className="text-danger ml-15">
                            {auto_update_attributesError.error_message}
                          </div>
                        )}
                      </div>
                    )
                  })}
                </>
              )}
            </div>

            <div className="allow_user_update_field">
              <span className="label-color-size">
                {t('audit.form-create-audit-1.allow-user-to-update-fields')} <br />
                <small>Allow users to edit select fields.</small>
                <Form.Check
                  type="switch"
                  id="custom-switch1"
                  label=""
                  className="ap-toggle mr-5 mt--3"
                  onChange={() => handleClearUserUpdateCheckbox()}
                  checked={allow_user_update_fields}
                  disabled={!audit_entities_attributes[0].entity_id || disabled ? true : false}
                />
              </span>

              {allow_user_update_fields && (
                <>
                  {audit_entities_attributes.map((singleGroup, index) => {
                    return entities.isUserFieldLoading ? (
                      <div className="row col-10 mt-15 loader-height-37">
                        <Spinner animation="border" role="status" />
                      </div>
                    ) : (
                      <>
                        <Form.Check
                          className="css-checkbox styled_checkbox pl-0"
                          type="checkbox"
                          aria-label="checkbox"
                          label="Allow users without write permissions to update fields"
                          onChange={() =>
                            setAllowUserWithoutEditPermission(!allow_user_without_edit_permission)
                          }
                          checked={allow_user_without_edit_permission}
                          disabled={disabled}
                        />
                        <CustomMultiSelectField
                          menuIsOpen={null}
                          optionItems={getUserUpdateOptionItem(
                            singleGroup.audit_entity_auto_update_fields_attributes
                          )}
                          value={singleGroup.audit_entity_user_fields_attributes}
                          handleChange={e => handleAllowUsersChange(index, e)}
                        />
                        {audit_fields_attributesError && (
                          <div className="text-danger">
                            {audit_fields_attributesError.error_message}
                          </div>
                        )}
                      </>
                    )
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default withTranslation()(GroupDetailsForm)
